module.exports = __webpack_public_path__ + "img/quest_icon_0054_kingcoins.6526d7ea.png";